export default {
  dispatch (eventName) {
    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
      var evt = document.createEvent('UIEvents')
      evt.initUIEvent(eventName, true, false, window, 0)
      window.dispatchEvent(evt)
    } else {
      window.dispatchEvent(new Event(eventName))
    }
  }
}
